/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Entity_FilterInputs */

const cs_documents_entity_filter = /** @type {(inputs: Documents_Entity_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ entity`)
};

const en_documents_entity_filter = /** @type {(inputs: Documents_Entity_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entity type`)
};

/**
* | output |
* | --- |
* | "Entity type" |
*
* @param {Documents_Entity_FilterInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_entity_filter = /** @type {((inputs?: Documents_Entity_FilterInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Entity_FilterInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_entity_filter(inputs)
	return cs_documents_entity_filter(inputs)
});